import { MainLayout } from "@/layouts/main-layout";

export const NotFound = () => {
  return (
    <MainLayout>
      <>Page not found</>
    </MainLayout>
  );
};
